import { CONTRACTOR_EDIT, CONTRACTOR_VIEW, CONTRACTOR_ADD } from '@/fixtures'

export default {
  path: 'contractor',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Contractor',
      component: () => import('@/views/menus/Contractor/Index'),
      meta: {
        permission: CONTRACTOR_VIEW
      }
    },
    {
      path: ':id/detail',
      name: 'Detail Contractor',
      component: () => import('@/views/menus/Contractor/Form'),
      meta: {
        permission: CONTRACTOR_VIEW
      }
    },
    {
      path: 'create',
      name: 'Create Contractor',
      component: () => import('@/views/menus/Contractor/Edit'),
      meta: {
        permission: CONTRACTOR_ADD
      }
    },
    {
      path: ':id/edit',
      name: 'Edit Contractor',
      component: () => import('@/views/menus/Contractor/Edit'),
      meta: {
        permission: CONTRACTOR_EDIT
      }
    }
  ]
}
